export default "__VITE_ASSET__DJUxO9kh__"